import { useParams } from "react-router-dom";
import { lazy, Suspense } from "react";

export default function FlowDocLoader() {
    const { flowName } = useParams();

    // Dynamically import the static documentation page
    const Page = lazy(() => 
        import(`../pages/flows/${flowName}.js`).catch(() => 
            import("./NotFound.js")
        )
    );

    return (
        <Suspense fallback={<p>Loading documentation</p>}>
            <Page />
        </Suspense>
    );
}